import { useContext, useEffect, useState } from "react";
import moment from "moment";
import Toastify from "toastify-js";
import fetchDataTrace from "../../../services/fetchDataTrace";
import { AuthContext } from "../../../contexts/AuthContext";
import { pusher } from "../../..";
import logo from "../../../assets/images/logo-icon.png"
import { useQuery } from "@tanstack/react-query";
import { handleFetchWallVisits } from "../../../api/visits";
import WallVisitNew from "./components/WallVisitNew";
import WallBookingNew from "./components/WallBookingNew";
import Moment from "react-moment";

export default function WallNew() {
  const { user, token, expire } = useContext(AuthContext);

  const [bookings, setBookings] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const start = moment(new Date()).format("YYYYMMDD");
  const end = moment(new Date()).format("YYYYMMDD");
  const [startDate, setStateDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [isBooking, setBooking] = useState<boolean>(true);

  const [dates, setDates] = useState<any>({
    startDate: moment(new Date()).format("YYYYMMDD"),
    endDate: moment(new Date()).format("YYYYMMDD"),
    isRange: false,
  });

  const site = user?.site?._id || "6224dcf60c5c49d9fec9218f";

  const date = new Date();

  const {
    data: visits,
    refetch: refetchVisits,
    isLoading: visitLoading,
  } = useQuery({
    queryKey: ["visits", site],
    queryFn: () => handleFetchWallVisits({ site }),
  });

  const handleFetchData = async ({ dates }: any) => {
    setLoading(true);
    const uri = `bookings/wall/${site}?start=${dates?.startDate}&end=${dates?.endDate}`;
    const response = await fetchDataTrace({
      uri,
      token,
      expire,
    });
    if (response?.success) {
      setBookings(response?.payload);
    }
    setLoading(false);
  };

  const handleFetchBookings = async () => {
    setLoading(true);
    const uri = `bookings/wall/${
      site || "6224dcf60c5c49d9fec9218f"
    }?start=${startDate}&end=${endDate}`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };



  useEffect(() => {
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();

      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    book.bind("confirm", function (data: any) {
      handleFetchBookings();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  useEffect(() => {
    handleFetchData({ dates });
  }, [dates]);

  useEffect(() => {
    const scan = pusher.subscribe(`visit`);
    scan.bind("in", function (data: any) {
      refetchVisits();
      Toastify({
        text: `${data?.payload?.vehicle || "-"}`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    scan.bind("out", function (data: any) {
      refetchVisits();
      Toastify({
        text: `${data?.payload?.vehicle || "-"}`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "red",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    return () => {
      pusher.unsubscribe("visit");
    };
  }, [site]);

  useEffect(() => {
    const interval = setInterval(() => {
      setBooking(!isBooking);
    }, 40000);

    return () => {
      clearInterval(interval);
    };
  }, [isBooking]);

  const bg = isBooking
    ? "https://ik.imagekit.io/ttltz/trace/bgi_kFeDSo2Yy.webp?updatedAt=1694078906289"
    : "https://ik.imagekit.io/ttltz/trace/readbg_uZHULGpWX.webp?updatedAt=1694157948613";

  return (
    <div className="relative h-screen">
      <div
        className={`h-full w-full absolute top-0 left-0 transition-opacity duration-1000`}
        style={{
          background: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0">
        <div className="flex flex-col justify-start mb-2">
          {isBooking ? (
            <div className="flex">
              <div className="pl-4 pr-2">
                <img src={logo} className="w-20 pt-2" />
              </div>
              <div className="flex flex-col justify-center items-center border-r">
                <button className="w-32 p-1 text-xl rounded-lg text-white mr-1 flex justify-center items-center font-bold">
                  Bookings
                </button>
                <div className="h-1 w-8 bg-white rounded-2xl"></div>
              </div>
              <div className="flex flex-col justify-center items-center pl-1">
                <button
                  onClick={() => setBooking(false)}
                  className="w-32 p-1 text-xl rounded-lg text-white mr-1 flex justify-center items-center font-bold"
                >
                  Stations
                </button>
                <div className="h-1 w-8 bg-toyota rounded-2xl"></div>
              </div>
            </div>
          ) : (
            <div className="flex">
              <div className="pl-4 pr-2">
                <img src={logo} className="w-20 pt-2" />
              </div>
              <div className="flex flex-col justify-center items-center border-r">
                <button
                  onClick={() => setBooking(true)}
                  className="w-32 p-1 text-xl rounded-lg text-white mr-1 flex justify-center items-center font-bold"
                >
                  Bookings
                </button>
                <div className="h-1 w-8 bg-toyota rounded-2xl"></div>
              </div>
              <div className="flex flex-col justify-center items-center pl-1">
                <button className="w-32 p-1 text-xl rounded-lg text-white mr-1 flex justify-center items-center font-bold">
                  Stations
                </button>
                <div className="h-1 w-8 bg-white rounded-2xl"></div>
              </div>
            </div>
          )}

          <div className="text-white font-bold mx-4 text-6xl pt-4 pb-4">
            <Moment format="DD MMMM YYYY">{date}</Moment>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="grid gap-x-0 grid-cols-12">
            <div className="col-span-12 sm:col-span-12 md:col-span-12">
              {isBooking ? (
                <WallBookingNew bookings={bookings} isLoading={isLoading} />
              ) : (
                <WallVisitNew
                  visits={visits?.payload || []}
                  isLoading={visitLoading}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
